export default "__VITE_ASSET__DnhMWjte__"